<template>

  <div class="doubleImage grid grid__item_span-12 p0 m0" :class="{ true: shadow }">

    <img v-for="(image, index) in item.project_double_images" :id="index" class="grid__item_span-7 p0 m0" :class="{ 'active': index === 0 }" :src="image.project_double_image.url" :alt="image.project_double_image.alt" :title="image.project_double_image.title" />
 
  </div>

</template> 

<script>

import animateScroll from '../../assets/js/projectAnimation.js'
var inViewport = require('vue-in-viewport-mixin')

export default {
  name: 'DoubleImage',
  props: [
    'item'
  ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      shadow: this.item.double_image_drop_shadow
    }
  },
  methods: {
    animateElements () {
      animateScroll.animate()
    }
  },
  mixins: [
    inViewport
  ],
  watch: {
    'inViewport.now': function (visible) {
      // console.log('This component is ' + (visible ? 'in-viewport' : 'hidden'))
      if (visible === true) {
        // console.log('YES')
        this.animateElements()
      } else {
        // console.log('no luck')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .singleImage {
    height: auto;
  }
  .singleImage img{
    width: 100%;
    height: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/components/project/doubleImage.vue